import { cbHttp } from "./http.service"

export const upgradeDomain = async (form: FormData): Promise<string> => {
    return cbHttp.post("/api/upgrade/upgradedomain", form);
}